/**
 * Did a human pick this document type, or did the app guess it?
 *
 * Sent to POST /documents/upload as `document_type_source`. "user" makes the
 * backend keep the type as-is instead of letting the LLM classifier overwrite
 * it — see backend/classifier.py::resolve_document_type.
 *
 * A deep-link preset (?doc_type= from the documents kebab menu) counts as a
 * human choice: it comes from an explicit action on the parent document.
 */
export function resolveTypeSource({ userOverrode, presetType } = {}) {
  return userOverrode || presetType ? "user" : "auto";
}
